import { Row } from 'farmhub-ui-core';
import styled from 'styled-components';

import { overlay } from 'styled';

export const WrapperBottom = styled.div`
  width: 100%;
  height: calc(100% - 12px);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 0px;
  overflow-y: scroll;
  overflow-x: hidden;

  ${overlay}
`;

export const WrapperBottomMobile = styled.div`
  width: 100%;
  max-height: calc(var(--window-height) - 162px);
  //height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  overflow: scroll;
  overflow-x: hidden;

  ${overlay}
`;

export const WrapperItem = styled.div`
  width: 100%;
  height: 100%;
  padding: 0px ${p => p.theme.app.padding.vertical};
  overflow-y: scroll;
  overflow-x: hidden;
  ${overlay}
`;

export const WrapperItemMobile = styled.div`
  width: 100%;
  height: 100%;

  &::-webkit-scrollbar-track {
    background-color: #ffffff;
  }

  &::-webkit-scrollbar {
    width: 6px;
    background: transparent !important;
    display: none;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #e0e0e0;
  }
`;

export const WrapperItemEmpty = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const TitleMobileWrapper = styled(Row)`
  height: ${p => p.theme.input.height.lg};
  width: 100%;
`;

export const Wrapper = styled.div`
  width: 100%;
`;
